import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

class SimpleSelect extends React.Component {
  state = {
    Category: 1,
    name: 'hai',
    labelWidth: 0,
  };
  componentDidMount() {

  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.handleSlectionChange(event.target.value)
  };

  render() {
    const { classes } = this.props;

    return (
      <form className={classes.root} autoComplete="off" style={{display:'inline-block', float:'right'}}>
        <FormControl variant="outlined" className={classes.formControl}>

          <Select
            value={this.state.Category}
            onChange={this.handleChange}
            name="Category"
            id="outlined-age-simple"
          >
            <MenuItem value={1}>Current</MenuItem>
            <MenuItem value={2}>History</MenuItem>
          </Select>
        </FormControl>
      </form>
    );
  }
}

SimpleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleSelect);


// WEBPACK FOOTER //
// ./src/components/SharedComponents/riskRegisterdropdownselection.js